angular.module('impactx.cscontract').controller('CSContractLimitListCtrl', [
    'selectedListItems',
    CSContractLimitListCtrl
]);

function CSContractLimitListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'CSContract'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/cscontract/templates/cscontractlimitlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/cscontract/limit/list',
        id: "cscontractLimitlist",
        mainAction: {id: "new", link: "#/csclimit/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "csclimit/" + selectedListItems.getFirstSelectedId();
    }
}